import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">Avaliações Verificadas</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            O Que Dizem Nossos Compradores
          </h2>
          <p className="mt-3 text-foreground-500 text-base max-w-xl mx-auto">
            Milhares de compradores confiam no CSSBuySpreadsheet para encontrar os melhores produtos da China.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-100 rounded-2xl p-6">
              <div className="flex gap-1 mb-3">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-primary-400 text-sm">
                    <i className="ri-star-fill"></i>
                  </span>
                ))}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{t.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">{t.text}</p>
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 rounded-full ${t.avatarBg} flex items-center justify-center text-background-50 text-xs font-semibold`}>
                  {t.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}